export default "45c7b2dd8560c4a5.svg"